<template>
  <header class="site-header" :class="{ 'is-open': mobileOpen }">
    <div class="header-glow"></div>
    <div class="header-inner">
      <router-link to="/index" class="brand" @click="closeMobile">
        <img src="/vfront/img/logo.png" alt="InnoSource" class="brand-logo" />
        <div class="brand-text">
          <strong>InnoSource</strong>
          <span>INNOVATION PARTNER</span>
        </div>
      </router-link>

      <button class="menu-toggle" type="button" @click="mobileOpen = !mobileOpen" aria-label="Open Menu">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav class="header-nav" aria-label="Main Navigation">
        <router-link to="/index" @click="closeMobile">Home</router-link>
        <router-link to="/profile" @click="closeMobile">会社案内</router-link>
        <router-link to="/service" @click="closeMobile">サービス</router-link>
        <router-link to="/recruit" @click="closeMobile">採用情報</router-link>
        <router-link to="/partner" @click="closeMobile">パートナー様へ</router-link>
        <router-link to="/inquiries" @click="closeMobile">お問合わせ</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'top',
  data() {
    return {
      mobileOpen: false,
    };
  },
  methods: {
    closeMobile() {
      this.mobileOpen = false;
    },
  },
};
</script>
